import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import SportsNavBar from "../../components/common/SportsNavBar";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import { fetchCricketNews } from "../../services/api";
import NewsCard from "../common/NewsCard";

function HomeExtra() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    const data = await fetchCricketNews();
    setArticles(data);
    setLoading(false);
  };

  if (loading) return <Loading />;

  return (
    <>
      <div>
        {/* ================= ROW 1 ================= */}
        <div className="ns-news-row">
          {articles.slice(0, 4).map((article, i) => (
            <NewsCard key={`r1-${i}`} article={article} />
          ))}
        </div>
      </div>

      {/* ================= ALL STYLES ================= */}
      <style>{`
        /* Section Title */
        .ns-section-title {
          margin: 30px 0 10px;
          font-size: 22px;
          font-weight: bold;
          color: #1a1a1a;
        }

        /* Grid Layout */
        .ns-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
          gap: 15px;
        }

        /* Card Styles */
        .ns-card {
          background: #fff;
          border: none;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        .ns-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
        }

        .ns-card img {
          width: 100%;
          height: 200px;
          object-fit: cover;
        }

        /* Content */
        .ns-content {
          padding: 12px;
          display: flex;
          flex-direction: column;
          flex-grow: 1;
        }

        /* Title Styles */
        .ns-title {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 6px;
          color: #222;
          line-height: normal;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        /* Description Styles */
        .ns-desc {
          font-size: 14px;
          color: #555;
          margin-bottom: 8px;
          line-height: normal;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        /* Links */
        .ns-card a {
          color: #0066ff;
          font-size: 14px;
          font-weight: 600;
          text-decoration: none;
        }

        /* Meta Information */
        .ns-meta {
          margin-top: 8px;
          font-size: 12px;
          color: #777;
        }

        .ns-news-row {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 15px;
          margin-bottom: 15px;
        }

        /* ================= RESPONSIVE DESIGN ================= */

        /* Large Tablets and Small Desktops (1200px and below) */
        @media (max-width: 1200px) {
          .ns-news-row {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }

        /* Small Tablets and Mobile (768px and below) */
        @media (max-width: 768px) {
          .ns-news-row {
            grid-template-columns: 1fr 1fr;
          }
        }

        /* Mobile Phones (480px and below) */
        @media (max-width: 480px) {
          .ns-news-row {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </>
  );
}

export default HomeExtra;
